import { useMemo } from 'react'
import { useChainId } from 'wagmi'
import { getContracts, getLegacyPositionManagers } from '@/config/contracts'
import { getNativeToken, getWrappedNativeToken, getDefaultTokens, NATIVE_TOKEN_ADDRESS } from '@/config/tokens'
import { getChain, getViemClient } from '@/config/chains'

export function useChainConfig() {
  const chainId = useChainId()
  return useMemo(() => ({
    chainId,
    chain: getChain(chainId),
    contracts: getContracts(chainId),
    nativeToken: getNativeToken(chainId),
    wrappedNativeToken: getWrappedNativeToken(chainId),
    defaultTokens: getDefaultTokens(chainId),
    legacyPositionManagers: getLegacyPositionManagers(chainId),
    viemClient: getViemClient(chainId),
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS,
  }), [chainId])
}
